import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { storageKeys } from '../../../../../../stores/DebuggerStore';
import { RED, WHITE } from '../../Styles';
import { StyledButton } from '../Styles';

export const LogJustErrorsButton = observer(() => {
  const {
    DebuggerStore: { setDebugItem },
  } = useStores();

  return (
    <StyledButton 
      bgColor={RED}
      color={WHITE}
      onClick={() => {
        setDebugItem(storageKeys.writeLogToDevWindow, true);
        setDebugItem(storageKeys.readLogWhenConnected, true);
        setDebugItem(storageKeys.writeToLogWhenConnected, false);
        setDebugItem(storageKeys.writeLogToConsole, false);
        setDebugItem(storageKeys.sendTimestampsToEngine, false);
        setDebugItem(storageKeys.writeTimestampsToConsole, false);
        setDebugItem(storageKeys.deleteOnBlockChange, true);
        setDebugItem(storageKeys.skipPingPongWhenConnected, false);
        // setDebugItem(storageKeys.maxLogStorageSizeInKb, 1000);
        // setDebugItem(storageKeys.maxMessageLength, 150);
        setDebugItem(storageKeys.engineLogLevel, 'off');
        setDebugItem(storageKeys.uiLogLevel, 'errors');
      }}
      style={{ cursor: 'pointer' }}
    >
      Log Errors Only
    </StyledButton>
  );
});

export default LogJustErrorsButton;
